import { createContext, type ReactNode, use } from 'react';
import type { UploadManager } from './uploadManager.ts';

const UploadsContext = createContext<UploadManager | null>(null);

export const UploadsProvider = ({
  manager,
  children,
}: {
  readonly manager: UploadManager;
  readonly children: ReactNode;
}) => <UploadsContext value={manager}>{children}</UploadsContext>;

export const useUploads = (): UploadManager => {
  const manager = use(UploadsContext);
  if (!manager) throw new Error('useUploads must be used inside <UploadsProvider>');
  return manager;
};
